import { BasicContainer } from '@/components/Common/BasicContainer/BasicContainer';
import COLORS from '@/constants/colors';
import CloseIcon from '@mui/icons-material/Close';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineItem,
  timelineItemClasses,
  TimelineSeparator,
} from '@mui/lab';
import {
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { useOrderHistoryViewController } from './OrderHistoryViewController';

export function OrderHistory() {
  const { uiState, actions } = useOrderHistoryViewController();

  return (
    <>
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          background: COLORS.gray_50,
          alignItems: 'self-start',
        }}
      >
        <Stack>
          <Typography>Historial Pedido</Typography>
          <Typography>#{uiState.orderNumber}</Typography>
        </Stack>
        <IconButton onClick={actions.onCloseClicked}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ background: COLORS.gray_50 }}>
        <BasicContainer
          content={
            <Timeline
              sx={{
                [`& .${timelineItemClasses.root}:before`]: {
                  flex: 0,
                  padding: 0,
                },
              }}
            >
              {uiState.events.toReversed().map((event, index) => {
                return (
                  <TimelineItem key={event.id}>
                    <TimelineSeparator>
                      <TimelineConnector
                        sx={{
                          visibility: index == 0 ? 'hidden' : undefined,
                          bgcolor: COLORS.green,
                        }}
                      />
                      <TaskAltIcon
                        sx={{
                          width: '30px',
                          height: '30px',
                          color: COLORS.green,
                        }}
                      />
                      <TimelineConnector
                        sx={{
                          bgcolor: COLORS.green,
                        }}
                      />
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: '12px', px: 2 }}>
                      <Typography variant="h6" component="span">
                        {event.title}
                      </Typography>
                      <Typography>{event.subtitle}</Typography>
                    </TimelineContent>
                  </TimelineItem>
                );
              })}
            </Timeline>
          }
        />
      </DialogContent>
    </>
  );
}
